import { getSortOptions, SortOptionKey } from 'global-services/register/OhsSortModels';
import { OhsUser } from 'user/OhsUser';
import { getWorkplaceOptions } from 'user/OhsUserServices';

export const injuryMgmtRecordSortOptions = getSortOptions([
  SortOptionKey.CreatedNewestToOldest,
  SortOptionKey.CreatedOldestToNewest,
  SortOptionKey.CreatedDateNewestToOldest,
  SortOptionKey.CreatedDateOldestToNewest,
]);
export default class OhsInjuryMgmtFilterModels {
  template: {
    viewPreset?: 'view_1' | 'view_2' | 'view_3' | 'view_4';
    archived: boolean;
    sort: string;
    workplaces: string[];
    categories: string[];
    subcategories: string[];
    templateTypes: string[];
    allocatedToWorkplace: boolean;
    notAllocated: boolean;
    workplaceOwned: boolean;
    tableSortKeyLists: {
      sortColAscDescOptions: { name: string; value: string }[];
    };
  };

  folder: {
    viewPreset?: 'view_1' | 'view_2' | 'view_3' | 'view_4';
    archived: boolean;
    sort: string;
    workplaces: string[];
    tableSortKeyLists: {
      sortColAscDescOptions: { name: string; value: string }[];
    };
  };

  record: {
    viewPreset?: 'view_1' | 'view_2' | 'view_3' | 'view_4';
    archived: boolean;
    sort: string;
    tableSortKeyLists: {
      sortColAscDescOptions: { name: string; value: string }[];
    };
  };

  constructor(user?: OhsUser) {
    let workplaceOptions = [];
    if (user) {
      const getWorkplaceLists = getWorkplaceOptions(user.configs);
      workplaceOptions = getWorkplaceLists.map((list: any) => list.id);
    }

    const sortOptions = [
      {
        name: 'Created Order: Newest to Oldest',
        value: '{ "key": "_id", "order": -1 }',
      },
      { name: 'Created Order: Oldest to Newest', value: '{ "key": "_id", "order": 1 }' },
      { name: 'Title: A to Z', value: '{ "key": "title", "order": 1 }' },
      { name: 'Title: Z to A', value: '{ "key": "title", "order": -1 }' },
    ];

    // Initialize template object
    this.template = {
      archived: false,
      sort: '{ "key": "_id", "order": -1 }',
      workplaces: workplaceOptions,
      categories: [],
      subcategories: [],
      templateTypes: [],
      allocatedToWorkplace: true,
      notAllocated: true,
      workplaceOwned: true,
      tableSortKeyLists: {
        sortColAscDescOptions: sortOptions,
      },
    };
    // Initialize folder object
    this.folder = {
      archived: false,
      sort: '{ "key": "_id", "order": -1 }',
      workplaces: workplaceOptions,
      tableSortKeyLists: {
        sortColAscDescOptions: sortOptions,
      },
    };
    // Initialize record object
    this.record = {
      archived: false,
      sort: injuryMgmtRecordSortOptions[0].value,
      tableSortKeyLists: {
        sortColAscDescOptions: injuryMgmtRecordSortOptions,
      },
    };
  }
}
